import { isAfter } from 'date-fns'
import {
    filter,
    sortBy,
} from 'lodash'
import moment, { Duration } from 'moment'
// import { DateTime, Duration } from 'luxon'

export function makeDurationFromStartEndTimes(
    startTime: Date | string | null | undefined,
    endTime: Date | string | null | undefined,
    toNow = false
): Duration | null {
    endTime = endTime ?? (toNow ? new Date() : null)
    if (!startTime || !endTime) return null
    // return DateTime.fromJSDate(new Date(startTime)).diff(DateTime.fromJSDate(new Date(endTime)))
    return moment.duration(moment(endTime).diff(moment(startTime)))
}

export type AppointmentTsKey =
    | '_timeCheckOutStart'
    | '_timeCheckOutEnd'
    | 'timeEncounterCheckedOut'
    | '_timeCheckInStart'
    | '_timeCheckInEnd'
    | '_timeIntakeStart'
    | '_timeIntakeEnd'
type AppointmentTsKeyVal = {
    key: AppointmentTsKey
    value: string | null
}

export const appointmentStartTimeKeys = [
    '_timeCheckInStart',
    '_timeCheckInEnd',
    '_timeIntakeStart',
    '_timeIntakeEnd',
]
export function getFirstAppointmentStartTimeKey(
    appointment: { 
        _timeCheckInStart?: string | null, 
        _timeCheckInEnd?: string | null, 
        _timeIntakeStart?: string | null,
        _timeIntakeEnd?: string | null
    }
): AppointmentTsKey | null {
    let timestamps: AppointmentTsKeyVal[] = appointmentStartTimeKeys.map(
        (key: any) => {
            return { key, value: appointment[key] }
        }
    )
    timestamps = filter(timestamps, ({ value }) => !!value)
    return timestamps?.[0]?.key ?? null
}

export const appointmentEndTimeKeys = [
    '_timeCheckOutStart',
    '_timeCheckOutEnd',
    'timeEncounterCheckedOut',
]
export function getEarliestAppointmentEndTimeKey(
    appointment: { 
        _timeCheckOutStart?: string | null, 
        _timeCheckOutEnd?: string | null, 
        timeEncounterCheckedOut?: string | null, 
    }
): AppointmentTsKey | null {
    let timestamps: AppointmentTsKeyVal[] = appointmentEndTimeKeys.map(
        (key: any) => {
            return { key, value: appointment[key] }
        }
    )
    timestamps = sortBy(
        filter(timestamps, ({ value }) => !!value),
        ({ value }) => (value ? new Date(value) : null)
    )
    return timestamps?.[0]?.key ?? null
}

export function getLastAppointmentsPredictedEndTime(
    appointments: ({ isActualEndTimeIndeterminate?: boolean | null, appointmentEstimate?: ({ estCheckoutTime?: string } | null) }[])
  ): Date | null {
    return appointments
      ?.filter(a => a?.isActualEndTimeIndeterminate)
      ?.reduce<Date | null>((mem, a) => {
        const estCheckout = a?.appointmentEstimate?.estCheckoutTime
          ? new Date(a.appointmentEstimate.estCheckoutTime)
          : null
        if (estCheckout && (!mem || isAfter(estCheckout, mem))) return estCheckout
        return mem
      }, null) ?? null
  }

export function getLastAppointmentsActualEndTime(
    appointments: ({ isActualEndTimeDeterminate?: boolean | null, _timeExamEnd?: string }[])
): Date | null {
    return appointments
    ?.filter(a => a?.isActualEndTimeDeterminate && a?._timeExamEnd)
    ?.reduce<Date | null>((mem, a) => {
        const examEndTime = a._timeExamEnd ? new Date(a._timeExamEnd) : null
        if (examEndTime && (!mem || isAfter(examEndTime, mem))) return examEndTime
        return mem
    }, null) ?? null
}
